<template>
    <v-container class="container">
        <table style="width:100%" v-if="!isMobile()">
            <tr>
                <th @click="tab='mapa'; deleteInterval(); ">
                  <button class="buttonBorder">
                    <div class="circle" v-if="tab=='mapa'"><img src="../../assets/Mapa.png" class="iconClicked"/></div>
                    <img v-if="tab!='mapa'" src="../../assets/Mapa.png" class="icon"/>
                    <div><h5>Mapa</h5></div>
                  </button>
                </th>
                <th @click="tab='users'; deleteInterval();reloadSameTab() " v-if="$store.getters.isAdmin">
                    <button class="buttonBorder">
                        <div class="circle" v-if="tab=='users'"><img  src="../../assets/userTab.png" class="iconClicked"/></div>
                        <img v-if="tab!='users'" src="../../assets/userTab.png" class="icon"/>
                        <div><h5>Usuarios</h5></div>
                    </button>
                </th>
                <th @click="tab='dispositivos'; deleteInterval();reloadSameTab()">
                    <button class="buttonBorder">
                        <div class="circle" v-if="tab=='dispositivos'"><img  src="../../assets/Dispositivo.png" class="iconClicked"/></div>
                        <img v-if="tab!='dispositivos'" src="../../assets/Dispositivo.png" class="icon"/>
                        <div><h5>Dispositivos</h5></div>
                    </button>
                </th>
                <th @click="tab='alertas'; deleteInterval();reloadSameTab()">
                    <button class="buttonBorder">
                        <div class="circle" v-if="tab=='alertas'"><img  src="../../assets/alertTab.png" class="iconClicked"/></div>
                        <img v-if="tab!='alertas'" src="../../assets/alertTab.png" class="icon"/>
                        <div><h5>Alertas</h5></div>
                    </button>
                </th>

                <th v-if="$store.getters.isAdmin" @click="tab='geocercas'; deleteInterval();">
                    <button class="buttonBorder">
                        <div class="circle" v-if="tab=='geocercas'"><img  src="../../assets/Geocerca.png" class="iconClicked"/></div>
                        <img v-if="tab!='geocercas'" src="../../assets/Geocerca.png" class="icon"/>
                        <div><h5>Geocercas</h5></div>
                    </button>
                </th>
                <th v-if="!$store.getters.isInstalador" @click="tab='reportes'; deleteInterval();">
                    <button class="buttonBorder">
                        <div class="circle" v-if="tab=='reportes'"><img  src="../../assets/Reporte.png" class="iconClicked"/></div>
                        <img v-if="tab!='reportes'" src="../../assets/Reporte.png" class="icon"/>
                        <div><h5>Reportes</h5></div>
                    </button>
                </th>
            </tr>
        </table>
        <div v-if="tab=='dispositivos' && !isMobile()">

            <v-layout>
                <v-flex>
                    <div>
                        <v-layout>
                            <v-flex xs12 sm6 offset-sm6>
                                <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
                <v-dialog
                        v-model="dialog"
                        transition="dialog-bottom-transition"
                        max-width="500px"
                        persistent
                        scrollable>
                    <v-card tile>
                        <v-toolbar card dark color="nav_background_color">
                            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Crear nuevo Dispositivo</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-form ref="formDevice" v-model="valid" lazy-validation>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <h2>Vehículo</h2>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="anio"
                                                label="Año"
                                                id="anio"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                                v-model="device.vehicleYear"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="marca"
                                                label="Marca"
                                                id="marca"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                                v-model="device.vehicleBrand"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="modelo"
                                                label="Modelo"
                                                id="modelo"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                                v-model="device.vehicleModel"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="placa"
                                                label="Placa"
                                                id="placa"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                                v-model="device.vehicleNumber"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <h2>Dispositivo</h2>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="name"
                                                label="Nombre del Equipo"
                                                id="name"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                                v-model="device.name"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="imei"
                                                label="IMEI"
                                                id="imei"
                                                v-model="device.imei"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="sim"
                                                label="SIM"
                                                id="sim"
                                                v-model="device.sim"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="model"
                                                label="Modelo"
                                                id="model"
                                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                                v-model="device.model"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <h2>Datos Instalación</h2>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-menu
                                                ref="menu"
                                                :close-on-content-click="false"
                                                v-model="menu"
                                                :nudge-right="40"
                                                :return-value.sync="date"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                readonly
                                                full-width
                                                min-width="290px">
                                            <v-text-field
                                                    slot="activator"
                                                    v-model="device.instalationDate"
                                                    label="Fecha de Instalación"
                                                    prepend-icon="event"
                                                    readonly
                                            ></v-text-field>
                                            <v-date-picker v-model="device.instalationDate"
                                                           @input="$refs.menu.save(device.instalationDate)"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <h2>Avatar</h2>
                                    </v-flex>
                                </v-layout>
                                <!--                                        <v-layout>-->
                                <!--                                            <v-flex xs12 sm10 offset-sm1>-->
                                <!--                                                <v-switch-->
                                <!--                                                        label="Inactivo / Activo"-->
                                <!--                                                        v-model="device.status"-->
                                <!--                                                ></v-switch>-->
                                <!--                                            </v-flex>-->
                                <!--                                        </v-layout>-->
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <img :src="device.image" width="15%">
                                        <v-btn class="btn-rounded" @click="dialogIcon=true" large color="primary">Cambiar Avatar
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm6 offset-sm4>
                                        <div>
                                            <v-btn class="btn-rounded" :disabled="!valid"
                                                   @click="saveDataWithTraccar" large color="primary">Guardar
                                            </v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <div style="flex: 1 1 auto;"></div>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-data-table
                v-if="!isMobile()"
                    :headers="headers"
                    :items="this.devices"
                    :search="search"
                    class="elevation-1"
                    sort-icon="mdi-menu-down"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                        <v-checkbox
                                :value="props.item.selected"
                                color="blue"
                                @change="selectedItem(props.item)"
                                hide-details
                        ></v-checkbox>
                    </td>
                    <td class="text-xs-left">
                        <div align="center"><img :src="props.item.image" width="40px"></div></td>
                    <td class="text-xs-left">{{ props.item.userName }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.imei }}</td>
                    <td class="text-xs-left">{{ props.item.sim }}</td>
                    <td class="text-xs-left">{{ props.item.model }}</td>
                    <td class="text-xs-left">{{ props.item.instalationDate }}</td>
                    <td class="text-xs-left">{{ props.item.lastAction }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    No se han encontrado resultados para "{{ search }}".
                </v-alert>
            </v-data-table>
            <v-btn class="btn-rounded" :disabled="!singleSelect" large color="primary" @click="dialogBlock = true">{{this.device.lastAction == 'Bloqueado'? 'Desbloquear' :'Bloquear'}}
            </v-btn>
        </div>
        <div v-if="tab=='alertas' && !isMobile()">
            <configuration/>
        </div>
        <div v-if="tab=='users' && !isMobile()">
            <users/>
        </div>
        <device-map v-if="tab=='mapa'" ref="formMap" ></device-map>
        <geo-fence v-if="tab=='geocercas'" ref="formGeo"></geo-fence>
        <device-report v-if="tab=='reportes'" ref="formRepo" ></device-report>

        <v-dialog
                v-model="dialogBlock"
                max-width="500px">
            <v-card tile>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout>
                            <h2>¿Seguro quieres
                                bloquear/abrir seguros
                                de {{this.editedIndex!=-1?this.devices[this.editedIndex].name:""}}?</h2>
                        </v-layout>
                        <v-layout>
                            <v-flex class="text-xs-center">
                                <div>
                                    <v-btn class="btn-rounded" :disabled="!valid"
                                           @click="sendDeviceAction()" large color="primary">Bloquear / Desbloquear
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
        <v-dialog v-if="dialogIcon==true"
                  v-model="dialogIcon"
                  max-width="700px">
            <v-card tile>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout>

<!--                            <table style="width:100%">-->
<!--                                <tr>-->
<!--                                    <th><img :src="props.item.icon1" @click="device.image=''; dialogIcon=false" width="70px" height="70px"></th>-->
<!--                                    <th><img :src="props.item.icon1" @click="device.image=''; dialogIcon=false" width="70px" height="70px"></th>-->
<!--                                    <th><img :src="props.item.icon1" @click="device.image=''; dialogIcon=false" width="70px" height="70px"></th>-->
<!--                                    <th><img :src="props.item.icon1" @click="device.image=''; dialogIcon=false" width="70px" height="70px"></th>-->
<!--                                    <th><img :src="props.item.icon1" @click="device.image=''; dialogIcon=false" width="70px" height="70px"></th>-->

<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>Jill</td>-->
<!--                                    <td>Smith</td>-->
<!--                                    <td>50</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>Eve</td>-->
<!--                                    <td>Jackson</td>-->
<!--                                    <td>94</td>-->
<!--                                </tr>-->
<!--                            </table>-->

                            <v-data-table
                                    :headers="headersCars"
                                    :items="cars"
                                    :search="search"
                                    class="elevation-1"
                                    sort-icon="mdi-menu-down"
                                    hide-actions
                                    hide-details
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon1" @click="device.image=props.item.icon1; dialogIcon=false" width="80%"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon2" @click="device.image=props.item.icon2; dialogIcon=false" width="80%"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon3" @click="device.image=props.item.icon3; dialogIcon=false" width="80%"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon4" @click="device.image=props.item.icon4; dialogIcon=false" width="80%"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon5" @click="device.image=props.item.icon5; dialogIcon=false" width="80%"></div>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-layout>
                        <v-layout>
                            <v-flex class="text-xs-center">
                                <div>
                                    <v-btn class="btn-rounded" :disabled="!valid" @click="dialogIcon=false" large color="primary">Guardar</v-btn>
                                    <v-btn class="btn-rounded" :disabled="!valid" @click="dialogIcon=false" large color="primary">Cerrar</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

    <div v-if="isMobile()">
      <device-mobile ></device-mobile>
    </div>


  </v-container>
</template>
<script>
    import Device from '../../model/Device';
    import DeviceMap from '../device/DeviceMap';
    import GeoFence from '../device/GeoFence';
    import Configuration from '../configuration/Configuration';
    import Users from '../client/Client';
    import DeviceReport from '../device/DeviceReport';
    import DeviceMobile from './mobile/DeviceMobile';

    export default {
        components: {
            DeviceMap,
            GeoFence,
          DeviceReport,
          DeviceMobile,
          Configuration,
          Users
        },
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogIcon: false,
                tab:"",
                cars:[

                  {icon1:"https://avatars-tupgps.s3.amazonaws.com/nuevos/1/1.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/nuevos/2/1.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/nuevos/3/1.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/nuevos/4/1.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/nuevos/5/1.png"},
                  {icon1:"https://avatars-tupgps.s3.amazonaws.com/nuevos/6/1.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/nuevos/7/1.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/nuevos/8/1.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/nuevos/9/1.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/nuevos/10/1.png"},
                  {icon1:"https://avatars-tupgps.s3.amazonaws.com/nuevos/11/1.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/nuevos/12/1.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/nuevos/13/1.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/nuevos/14/1.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/nuevos/15/1.png"},
                  {icon1:"https://avatars-tupgps.s3.amazonaws.com/nuevos/16/1.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/nuevos/17/1.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/nuevos/27/1.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/nuevos/19/1.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/nuevos/28/1.png"},
                  {icon1:"https://avatars-tupgps.s3.amazonaws.com/nuevos/21/1.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/nuevos/22/1.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/nuevos/23/1.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/nuevos/29/1.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/nuevos/25/1.png"},
                ],
                headers: [
                    {text: '', value: ''},
                    {text: 'Avatar', value: 'avatar'},
                    {text: 'Cuenta', value: 'userName'},
                    {text: 'Nombre del equipo', value: 'name'},
                    {text: 'IMEI', value: 'imei'},
                    {text: 'SIM', value: 'sim'},
                    {text: 'Modelo', value: 'model'},
                    {text: 'Fecha Instalación', value: 'instalationDate'},
                    {text: 'Estado', value: 'lastAction'},
                ],
                headersCars: [
                    {text: '', value: ''},
                    {text: '', value: ''},
                    {text: '', value: ''},
                    {text: '', value: ''},
                    {text: '', value: ''}
                ],
                markers: [],
                editedIndex: -1,
                device: new Device(),
                devices: [],
                date: "",
                menu: false,
                deviceObject: {id: "", value: "", date: new Date()},
                singleSelect: false,
                active: 0,
                dialogBlock: false,
                devicesImport:[]
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.device = new Device();
                this.valid = false;
                this.dialog = false;
            },
            newDevice() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.device = new Device();
            },

            saveDataWithTraccar(){
              if(this.device.idTraccar==null){
                this.$store.dispatch('addDeviceTraccar', {
                  "name": this.device.name,
                  "uniqueId": this.device.imei,
                  "status": "online",
                  "disabled": false,
                  "lastUpdate": "2019-08-24T14:15:22Z",
                  "positionId": 0,
                  "groupId": 0,
                  "phone": this.device.sim,
                  "model": "GT06",
                  "contact": "",
                  "category": "GT06"
                }).then(
                    response => {
                      this.device.idTraccar = response.data.id
                      this.saveData(true)
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
                );
              }else{
                this.saveData(true)
              }
            },

            saveData(reload) {
                if (this.$refs.formDevice.validate()) {
                  let loginVar = ""
                  if(this.$store.state.deviceUser!=""){
                    loginVar=this.$store.state.deviceUser.login
                  }else{
                    loginVar= this.device.login
                  }
                  this.$store.dispatch('getOneUser', loginVar).then(
                      responseUser => {
                        this.device.login=loginVar
                        if(this.$store.state.deviceUser.firstName!=null){
                          this.device.userName = this.$store.state.deviceUser.firstName + " "+this.$store.state.deviceUser.lastName
                        }
                        this.deviceObject.value = JSON.stringify(this.device)
                        this.deviceObject.id = this.device.id
                        this.deviceObject.user = responseUser.data

                        if (this.device.id != null && this.device.id != "") {
                          this.$store.dispatch('updateDevice', this.deviceObject).then(
                              response => {
                                if(reload){
                                  this.reload();
                                }
                              },
                              error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                              }
                          );
                        } else {
                          this.deviceObject.date = new Date()
                          this.deviceObject.user = responseUser.data
                          this.deviceObject.user.clientData = ""
                          this.$store.dispatch('addDevice', this.deviceObject).then(
                              response => {
                                if(reload){
                                  this.reload();
                                }
                              },
                              error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                              }
                          );
                        }
                        this.dialog = false;
                      },
                      error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                      }
                  );


                }
            },
            editItem(item) {
                this.editedIndex = this.devices.indexOf(item);
                this.device = Object.assign({}, item);
               if(this.device.idTraccar==null){
                 this.$store.dispatch('addDeviceTraccar', {
                   "name": this.device.name,
                   "uniqueId": this.device.imei,
                   "status": "online",
                   "disabled": false,
                   "lastUpdate": "2019-08-24T14:15:22Z",
                   "positionId": 0,
                   "groupId": 0,
                   "phone": this.device.sim,
                   "model": "GT06",
                   "contact": "",
                   "category": "GT06"
                 }).then(
                     response => {
                       this.device.idTraccar = response.data.id
                       this.saveData(false).then(response2 => {
                         this.dialog = true;
                       })
                     },
                     error => {
                       this.$store.state.progress = false;
                       this.$store.state.dialogError = true;
                     }
                 );

               }else{
                 this.dialog = true;
               }


            },
            selectedItem(item) {
                this.singleSelect = false
                this.editedIndex = this.devices.indexOf(item);
                for (let i = 0; i < this.devices.length; i++) {
                    this.devices[i].selected = false
                }
                this.devices[this.editedIndex].selected = true
                this.device = this.devices[this.editedIndex]
                this.singleSelect = true
            },
            selectedItemMap(item) {
                this.singleSelect = false
                this.editedIndex = this.devices.indexOf(item);
                if (this.devices[this.editedIndex].selected) {
                    this.devices[this.editedIndex].selected = false
                    for (let i = 0; i < this.markers.length; i++) {
                        if (this.markers[i].position.imei == this.devices[this.editedIndex].imei) {
                            this.markers.splice(i, 1)
                        }
                    }
                } else {
                    this.$store.dispatch('getDevicesLocationTraccar', this.devices[this.editedIndex].idTraccar).then(response => {
                        let respPosition = {
                            position: {
                                lat: response.data.result[0].lat,
                                lng: response.data.result[0].lng,
                                imei: this.devices[this.editedIndex].imei
                            },
                            icon: {
                                url: 'https://pngwebicons.com/uploads/car/ico/car_icon3898.ico',
                                size: {width: 80, height: 80, f: 'px', b: 'px'},
                                scaledSize: {width: 60, height: 60, f: 'px', b: 'px'}
                            }
                        }
                        this.markers.push(respPosition)
                        this.devices[this.editedIndex].selected = true

                    })
                }
                this.singleSelect = true
            },

            sendDeviceAction() {
                if (this.device.lastAction == 'Bloqueado' || this.device.lastAction == '') {
                    this.$store.dispatch('sendDeviceActionTraccar', {
                          "deviceId": this.device.idTraccar,
                          "description": "version",
                          "type": "custom",
                          "attributes": {
                            "data": "Relay,0#"
                          }
                        }
                    ).then(response => {
                        this.device.lastAction = 'Desbloqueado'
                        this.saveData(false)
                        this.dialogBlock = false
                    })
                } else {
                    this.$store.dispatch('sendDeviceActionTraccar', {
                      "deviceId": this.device.idTraccar,
                      "description": "version",
                      "type": "custom",
                      "attributes": {
                        "data": "Relay,1#"
                      }
                    }).then(response => {
                        this.device.lastAction = 'Bloqueado'
                        this.saveData(false)
                        this.dialogBlock = false
                    })
                }
            },
            deleteItem(item) {
                this.editedIndex = this.devices.indexOf(item);
                this.device = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteDevice', this.device.id).then(response => {
                    this.reload()
                })
            },
            isMobile() {
              if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.tab="dispositivos"
                return true
              } else {
                return false
              }
            },
            reload() {
                let search = ""
                if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
                    search = this.$store.state.idUser
                } else {
                    search = this.$store.state.deviceUser.login
                }
                // this.$store.dispatch('getDevicesByUserLogin', search).then(response => {
                //     this.devices = []
                //     this.geoFences = []
                //     for (let i = 0; i < response.data.length; i++) {
                //         let object = JSON.parse(response.data[i].value)
                //         object.id = response.data[i].id
                //         object.selected = false
                //         object.user = response.data[i].user
                //         this.devices.push(object)
                //     }
                //   this.devices.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
                  
                // })
                this.tab="mapa"
            },
          reloadSameTab() {
            let search = ""
            if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
              search = this.$store.state.idUser
            } else {
              search = this.$store.state.deviceUser.login
            }

              this.$store.dispatch('getRelatedDevicesByUserLoginFull', search).then(responseRelated => {
                this.devices = []
                this.geoFences = []
                  for (let i = 0; i < responseRelated.data.length; i++) {
                      let object = JSON.parse(responseRelated.data[i].value)
                      object.id = responseRelated.data[i].id
                      object.selected = false
                      object.user = responseRelated.data[i].user
                      if(!this.$store.getters.isActiveDevice(object)){
                        continue
                      }
                      this.devices.push(object)
                  }
                  this.devices.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
              })
             //This are for the SUPER USER FROM A COMPANY
            
             
              if (search === 'grupooro357') {
                  try {
                      this.$store.dispatch('getOneUser', search).then(responseData => {
                          if (responseData.data.clientData != null) {
                              let clientData = JSON.parse(responseData.data.clientData)
                              if (clientData.userChildren && clientData.userChildren.length > 0) {
                                  for (let j = 0; j < clientData.userChildren.length; j++) {
                                      if (clientData.userChildren[j] != null && clientData.userChildren[j].login != null) {
                                          this.$store.dispatch('getOneUser', clientData.userChildren[j].login).then(responseDevices => {
                                              if (responseDevices.data.clientData) {
                                                  let clientDataForDevices = JSON.parse(responseDevices.data.clientData);
                                                  for (let z = 0; z < clientDataForDevices.devices.length; z++) {
                                                      this.devices.push(clientDataForDevices.devices[z]);
                                                  }
                                              }
                                          })
                                      }
                                  }

                              }

                          }

                      })
                  } catch (e) {
                    //ERROR TO PROCESS
                  }
                  ;
              }
             
          },
            mark(event) {
                this.geoFence.position = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng(),
                }
            },
          deleteInterval(){
              clearInterval(this.$store.state.intervalMap)
              const highestIntervalId = window.setInterval(() => {}, 1000); // Get the highest interval ID
                for (let i = 0; i <= highestIntervalId; i++) {
                    window.clearInterval(i); // Clear each interval
                }
          },
          insertDevices(){
            //   console.log("datos total> "+this.devicesImport.length)
            // let contadorTotal=0
            //   this.$store.dispatch('getClients').then(response => {
            //     for (let i = 0; i < response.data.length; i++) {
            //       let cont=0
            //       for (let j = 0; j < this.devicesImport.length; j++) {
            //         if(response.data[i].login.toLowerCase()==this.devicesImport[j].login.toLowerCase()){
            //           contadorTotal++
            //           cont++
                      // this.deviceObject = {}
                      // this.devicesImport[j].image="https://avatars-tupgps.s3.amazonaws.com/autostupgs/PNG/PNG/4.png"
                      // this.devicesImport[j].idUser = response.data[i].id
                      // this.devicesImport[j].userName = response.data[i].firstName + " "+response.data[i].lastName
                      //
                      // this.deviceObject.value = JSON.stringify(this.devicesImport[j])
                      // this.deviceObject.user = response.data[i]
                      // this.deviceObject.date = new Date()
                      // this.$store.dispatch('addDevice', this.deviceObject)
          //           }
          //         }
          //         if(cont==0){
          //           console.log("no hay datos para el usuario>"+response.data[i].login)
          //         }
          //       }
          //       console.log("total que se insertaron>"+contadorTotal)
          //
          //
          //
          //       for (let j = 0; j < this.devicesImport.length; j++) {
          //         let cont=0
          //
          //         for (let i = 0; i < response.data.length; i++) {
          //           if(response.data[i].login.toLowerCase()===this.devicesImport[j].login.toLowerCase()){
          //             cont++
          //           }
          //         }
          //         if(cont==0){
          //           console.log("2.- no hay datos para el usuario>"+this.devicesImport[j].login+"wwqwww")
          //         }
          //       }
          //
          //     })
          //
          //
           }

        },
        computed: {},
      created() {
        this.$store.state.deviceUser = ''
        this.reload()
        this.devicesImport= [
        ]
        //this.insertDevices()
        },

    };
</script>

<style scoped>
    .circle {
        padding-top: 12px;
        width: 70px;
        height: 70px;
        background: #4e474c;
        -moz-border-radius: 50px;
        -webkit-border-radius: 50px;
        border-radius: 50px;
    }
    .buttonBorder{
        border: none;
        outline:none;
    }
    .iconClicked{
        width:40px;
    }
    .icon{
        width:40px;
    }
    .container{
      max-width: 100% !important;
      padding: 0%;
    }
</style>



// WEBPACK FOOTER //
// src/components/device/Device.vue